const AnvilIcon = () => (
  <svg viewBox="0 0 64 64" fill="currentColor" width="100%" height="100%">
    <defs>
      <linearGradient id="anvilMetal" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#8a8a8a"/>
        <stop offset="50%" stopColor="#5a5a5a"/>
        <stop offset="100%" stopColor="#3a3a3a"/>
      </linearGradient>
      <linearGradient id="anvilHighlight" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#9a9a9a"/>
        <stop offset="100%" stopColor="#6a6a6a"/>
      </linearGradient>
      <linearGradient id="hammerWood" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#6b4423"/>
        <stop offset="50%" stopColor="#8B4513"/>
        <stop offset="100%" stopColor="#5c3a1d"/>
      </linearGradient>
      <linearGradient id="hammerMetal" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" stopColor="#7a7a7a"/>
        <stop offset="30%" stopColor="#5a5a5a"/>
        <stop offset="100%" stopColor="#4a4a4a"/>
      </linearGradient>
      <filter id="anvilGlow">
        <feGaussianBlur stdDeviation="0.5" result="glow"/>
        <feMerge>
          <feMergeNode in="glow"/>
          <feMergeNode in="SourceGraphic"/>
        </feMerge>
      </filter>
    </defs>
    
    {/* Base pedestal */}
    <path d="M14 56 L50 56 L52 58 L12 58 Z" fill="#2a2a2a"/>
    <path d="M16 52 L48 52 L50 56 L14 56 Z" fill="#3a3a3a"/>
    <path d="M18 48 L46 48 L48 52 L16 52 Z" fill="url(#anvilMetal)"/>
    
    {/* Coluna central */}
    <path d="M22 48 L42 48 L44 42 L20 42 Z" fill="#4a4a4a"/>
    <path d="M20 42 L44 42 L42 36 L22 36 Z" fill="#5a5a5a"/>
    
    {/* Corpo principal da bigorna */}
    <path d="M6 36 L58 36 L56 30 L8 30 Z" fill="url(#anvilMetal)"/>
    <path d="M8 30 L56 30 L54 26 L52 24 L12 24 L10 26 Z" fill="url(#anvilHighlight)"/>
    
    {/* Superfície de trabalho */}
    <path d="M10 24 L54 24 L52 20 L12 20 Z" fill="#6a6a6a"/>
    <rect x="12" y="18" width="40" height="4" fill="#7a7a7a" rx="1"/>
    
    {/* Chifre da bigorna (horn) */}
    <path d="M52 20 L60 16 L62 14 L60 12 L54 14 L52 18 Z" fill="url(#anvilHighlight)"/>
    <path d="M54 14 L60 12 L58 11 L54 13 Z" fill="#8a8a8a"/>
    
    {/* Cauda da bigorna (heel) */}
    <path d="M12 20 L4 18 L2 16 L4 14 L10 16 L12 18 Z" fill="url(#anvilHighlight)"/>
    
    {/* Orifício (hardy hole) */}
    <rect x="40" y="18" width="4" height="4" fill="#2a2a2a" rx="0.5"/>
    <rect x="41" y="19" width="2" height="2" fill="#1a1a1a"/>
    
    {/* Orifício pritchel */}
    <circle cx="34" cy="20" r="1.5" fill="#2a2a2a"/>
    <circle cx="34" cy="20" r="0.8" fill="#1a1a1a"/>
    
    {/* Martelo */}
    <rect x="24" y="2" width="3" height="16" fill="url(#hammerWood)" rx="0.5"/>
    <path d="M25.5 3 L25.5 16" stroke="#5c3a1d" strokeWidth="0.3"/>
    
    {/* Cabeça do martelo */}
    <rect x="17" y="0" width="18" height="7" fill="url(#hammerMetal)" rx="1"/>
    <rect x="17" y="0" width="18" height="2.5" fill="#8a8a8a" rx="1"/>
    <path d="M17 3.5 L35 3.5 L35 5 L17 5 Z" fill="#4a4a4a"/>
    
    {/* Detalhes do martelo */}
    <rect x="18" y="1" width="3" height="5" fill="#6a6a6a" rx="0.5"/>
    <rect x="31" y="1" width="3" height="5" fill="#6a6a6a" rx="0.5"/>
    
    {/* Faíscas */}
    <circle cx="28" cy="12" r="1" fill="#ff6b35" opacity="0.8" filter="url(#anvilGlow)"/>
    <circle cx="32" cy="14" r="0.6" fill="#ffb347" opacity="0.7"/>
    <circle cx="24" cy="13" r="0.5" fill="#ff6b35" opacity="0.6"/>
    <circle cx="36" cy="11" r="0.4" fill="#ffb347" opacity="0.5"/>
    
    {/* Brilhos metálicos */}
    <path d="M14 26 L18 26 L17 28 L13 28 Z" fill="#9a9a9a" opacity="0.4"/>
    <path d="M44 26 L48 26 L49 28 L45 28 Z" fill="#9a9a9a" opacity="0.3"/>
    <line x1="14" y1="19" x2="50" y2="19" stroke="#9a9a9a" strokeWidth="0.5" opacity="0.3"/>
  </svg>
)

export default AnvilIcon
